module.exports = __webpack_public_path__ + "media/images/iconTrendUp__okGreen--dark-2fb2c2b3022200e9a98e6c03745e0997.png";